import { ListBox, Select } from '@heroui/react'
import { useTypedAppFormContext } from '@zealth/core/form/contexts'
import type { MoneyWithPeriodFormFieldProps } from '@zealth/core/formFields/types'

import { MoneyFormField } from './MoneyFormField'

// `value` is the stored ValuePeriod (must match the enum); `label` is display
// copy only. Annual is listed first; yearly is stored.
const PERIOD_OPTIONS = [
  { value: 'yearly', label: 'Annual' },
  { value: 'monthly', label: 'Monthly' },
]

const PeriodSelect = ({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) => (
  <Select
    aria-label="Period"
    value={value}
    onChange={selected => onChange(String(selected))}
  >
    <Select.Trigger className="flex items-center w-32 h-[56px] rounded-sm border border-[rgba(0,0,0,0.23)] shadow-none">
      <Select.Value className="text-base" />
      <Select.Indicator />
    </Select.Trigger>
    <Select.Popover className="rounded-sm text-base">
      <ListBox>
        {PERIOD_OPTIONS.map(option => (
          <ListBox.Item
            key={option.value}
            id={option.value}
            textValue={option.label}
          >
            {option.label}
            <ListBox.ItemIndicator />
          </ListBox.Item>
        ))}
      </ListBox>
    </Select.Popover>
  </Select>
)

// Renders the money amount (bound to the ambient field — the question id) with
// the period picker inline to its right, bound to the companion `<id>Period`
// answer key. Both write independent answers; the build pipeline annualizes the
// amount using the period.
export const MoneyWithPeriodFormField = ({
  label,
  placeholder,
  optional,
  periodName,
}: MoneyWithPeriodFormFieldProps) => {
  const form = useTypedAppFormContext({})

  return (
    <div className="flex flex-row items-start gap-2">
      <div className="flex-1">
        <MoneyFormField
          label={label}
          placeholder={placeholder}
          optional={optional}
        />
      </div>
      <form.AppField name={periodName}>
        {periodField => (
          <PeriodSelect
            value={(periodField.state.value as string) ?? ''}
            onChange={periodField.handleChange}
          />
        )}
      </form.AppField>
    </div>
  )
}
